module.exports = __webpack_public_path__ + "img/340.c8655b8.png";